import api from 'api/axios/foka'
import { serializeError } from 'utils'
import { createTableSlice } from 'features/dashboard/table/createTableSlice'
import { DashboardTypes } from 'features/Codes'
import { filterMetricColumns } from 'features/dashboard/utils/dashboardUtils'
import { createAsyncThunk } from '@reduxjs/toolkit'

export const fetchCampaignSummary = createAsyncThunk(
  'dashboard/fetchCampaignSummary',
  async ({ from, to, columns, filters }) => {
    const summary = await api.dashboard
      .getCampaignTableReportTotal({
        from,
        to,
        columns,
        filters,
      })
      .then(res => res?.data?.reportResponse?.data[0] || {})
      .catch(() => ({}))
    return { summary }
  }
)

export const fetchCampaignTable = createAsyncThunk(
  'dashboard/fetchCampaignTable',
  async (noArgs, { getState, dispatch, rejectWithValue }) => {
    let error
    const {
      common: { from, to },
      filter: { filters },
      table: {
        config: {
          columns: { [DashboardTypes.CAMPAIGN]: columns },
        },
        campaignTable: { page, sort },
      },
    } = getState().dashboard
    const metricColumns = filterMetricColumns(columns)
    if (metricColumns.length > 0) {
      dispatch(
        fetchCampaignSummary({
          from,
          to,
          columns: metricColumns,
          filters,
        })
      )
    }
    const { content, totalElements } = await api.dashboard
      .getCampaignTable({
        from,
        to,
        page,
        sort,
        filters,
      })
      .then(res => res?.data?.result)
      .catch(err => {
        error = serializeError(err)
        return {
          content: [],
          totalElements: 0,
        }
      })
    if (error) {
      return rejectWithValue(error)
    } else {
      let metricError
      const metrics =
        totalElements === 0 || metricColumns.length === 0
          ? {}
          : await api.dashboard
              .getCampaignTableReport({
                from,
                to,
                columns: metricColumns,
                ids: content.map(({ id }) => id),
              })
              .then(res => res?.data?.metrics)
              .catch(() => {
                metricError = '지표 데이터를 불러오지 못했습니다.'
                return {}
              })
      return {
        totalElements,
        content: content.map(item => ({
          ...item,
          ...metrics[item.id],
        })),
        error: metricError,
      }
    }
  }
)

const campaignTableSlice = createTableSlice({
  type: DashboardTypes.CAMPAIGN,
  fetcher: fetchCampaignTable,
  summaryFetcher: fetchCampaignSummary,
})
const { actions, reducer } = campaignTableSlice
export const campaignTableActions = actions
export const {
  reset,
  toggleSelectedId,
  setSelectedIds,
  setPage,
  setSort,
  clearError,
  setStatus,
} = actions
export default reducer
